import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'

class NRTImage extends Component {

    render() {

        const {
            url
        } = this.props

        return (
            <div className={'mc-ead-content-image'}>

                <div className="content">
                    <div className="mc-ead-content-card">
                        <img src={url}/>
                    </div>
                </div>

            </div>
        )
    }
}


NRTImage.propTypes = {
    url: PropTypes.string.isRequired,
}

NRTImage.defaultProps = {}

export default NRTImage



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/Image/index.js